import { template } from '../utils/template';
import * as CookieConsent from 'vanilla-cookieconsent';
window.cookies = CookieConsent;
let im;
const loadAndParseLanguage = async url => {
  const resp = await fetch(url);
  const text = await resp.text();
  const replacedString = text.replaceAll('LOCALHOST', window.location.hostname);
  return JSON.parse(replacedString);
};
class CookieBanner {
  chatBubbleListener(e) {
    e.preventDefault();
    window.$chatwoot.toggle();
  }
  toggleChatBubble() {
    if (this.chatBubble) {
      if (CookieConsent.acceptedCategory('chat')) {
        this.chatBubble.style = 'display:block';
      } else {
        this.chatBubble.style = 'display:none';
      }
    }
  }
  toggleOptoutNotices() {
    // Cookiebot-era convention kept in content/lang strings: elements with
    // class `cookieconsent-optout-<category>` are visible only while that
    // category is NOT consented (e.g. the research autocomplete hint).
    document
      .querySelectorAll('[class*="cookieconsent-optout-"]')
      .forEach(el => {
        const match = el.className.match(/cookieconsent-optout-([a-z]+)/);
        if (!match) return;
        el.style.display = CookieConsent.acceptedCategory(match[1])
          ? 'none'
          : '';
      });
  }
  showConsentInformation() {
    if (!this.statusElement || !this.statusTemplate) return;
    const dateOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short',
    };
    const cookie = CookieConsent.getCookie();
    const preferences = CookieConsent.getUserPreferences();
    const consentDate = new Date(cookie.lastConsentTimestamp);
    this.statusElement.innerHTML = this.statusTemplate({
      ConsentAcceptType: preferences.acceptType,
      ConsentID: cookie.consentId,
      ConsentLastEdited: consentDate.toLocaleString('en-GB', dateOptions),
    });
  }
  logConsent() {
    // Retrieve all the fields
    const cookie = CookieConsent.getCookie();
    const preferences = CookieConsent.getUserPreferences();

    // In this example we're saving only 4 fields
    const userConsent = {
      ConsentID: cookie.consentId,
      ConsentURL: window.location.href,
      ConsentPreferences: preferences.acceptedCategories,
      ConsentAcceptType: preferences.acceptType,
      acceptedCategories: preferences.acceptedCategories,
      rejectedCategories: preferences.rejectedCategories,
    };

    fetch('/cookies/saveConsent', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userConsent),
    }).then(() => {
      this.showConsentInformation();
    });
  }
  constructor(element) {
    this.element = element;
    this.statusElement = document.querySelector('.js-cookieconsent');
    if (this.statusElement && document.getElementById('ConsentStatus')) {
      this.statusTemplate = template(
        document.getElementById('ConsentStatus').text
      );
    }
    this.chatBubble = document.querySelector('.js-comForm');
    if (this.chatBubble)
      this.chatBubble.addEventListener('click', this.chatBubbleListener);

    let autoShow = true;
    if (window.location.hash && window.location.hash === '#NoCookies') {
      autoShow = false;
    }
    CookieConsent.run({
      onFirstConsent: () => {
        this.logConsent();
      },
      onConsent: () => {
        this.toggleChatBubble();
        this.toggleOptoutNotices();
        this.showConsentInformation();
      },
      onChange: ({ changedCategories }) => {
        if (changedCategories.includes('chat')) {
          this.toggleChatBubble();
        }
        this.toggleOptoutNotices();
        this.logConsent();
      },
      root: 'body',
      autoShow: autoShow,
      // disablePageInteraction: true,
      // hideFromBots: true,
      mode: 'opt-in',
      revision: 0,

      cookie: {
        name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        // expiresAfterDays: 365,
      },

      // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
      guiOptions: {
        consentModal: {
          layout: 'bar inline',
          position: 'bottom center',
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: 'box',
          equalWeightButtons: false,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        preferences: {},
        statistics: {},
        chat: {},
        media: {
          autoClear: {
            cookies: [
              {
                name: /^(_ga|_gid|im_)/,
              },
            ],
          },
          services: {
            youtube: {
              label: 'Youtube Embed',
              onAccept: () => im.acceptService('youtube'),
              onReject: () => im.rejectService('youtube'),
            },
            vimeo: {
              label: 'Vimeo Embed',
              onAccept: () => im.acceptService('vimeo'),
              onReject: () => im.rejectService('vimeo'),
            },
            spotify: {
              label: 'Spotify Embed',
              onAccept: () => im.acceptService('spotify'),
              onReject: () => im.rejectService('spotify'),
            },
          },
        },
      },

      language: {
        default: 'en',
        autoDetect: 'document',
        translations: {
          en: async () => {
            return loadAndParseLanguage(
              '_resources/themes/unibz/cookies/en.json'
            );
          },
          de: async () => {
            return loadAndParseLanguage(
              '_resources/themes/unibz/cookies/de.json'
            );
          },
          it: async () => {
            return loadAndParseLanguage(
              '_resources/themes/unibz/cookies/it.json'
            );
          },
          ll: async () => {
            return loadAndParseLanguage(
              '_resources/themes/unibz/cookies/ll.json'
            );
          },
        },
      },
    });

    im = window.iframemanager();

    // Example with youtube embed
    im.run({
      currLang: 'en',
      onChange: ({ changedServices, eventSource }) => {
        if (eventSource.type === 'click') {
          const servicesToAccept = [
            ...CookieConsent.getUserPreferences().acceptedServices['media'],
            ...changedServices,
          ];

          CookieConsent.acceptService(servicesToAccept, 'media');
        }
      },
      services: {
        youtube: {
          embedUrl: 'https://www.youtube.com/embed/{data-id}',
          thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
          iframe: {
            referrerpolicy:
              "strict-origin-when-cross-origin",
            allow:
              'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;',
          },
          languages: {
            en: {
              notice:
                'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
              loadBtn: 'Load video',
              loadAllBtn: "Don't ask again",
            },
          },
        },
        vimeo: {
          embedUrl: 'https://player.vimeo.com/video/{data-id}',
          iframe: {
            allow: 'fullscreen; picture-in-picture, allowfullscreen;',
          },

          thumbnailUrl: async (dataId, setThumbnail) => {
            const url = `https://vimeo.com/api/v2/video/${dataId}.json`;
            const response = await (await fetch(url)).json();
            const thumbnailUrl = response[0]?.thumbnail_large;
            thumbnailUrl && setThumbnail(thumbnailUrl);
          },

          languages: {
            en: {
              notice:
                'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://vimeo.com/terms" target="_blank">terms and conditions</a> of vimeo.com.',
              loadBtn: 'Load video',
              loadAllBtn: "Don't ask again",
            },
          },
        },
        spotify: {
          embedUrl: 'https://open.spotify.com/embed/episode/{data-id}?theme=0',

          iframe: {
            allow:
              'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture',
          },

          // thumbnailUrl: async (dataId, setThumbnail) => {
          //   const url = `https://embed.spotify.com/oembed/?url=https://open.spotify.com/episode/${dataId}&callback=callme`;
          //   const response = await (await fetch(url)).json();
          //   const thumbnailUrl = response[0]?.thumbnail_url;
          //   thumbnailUrl && setThumbnail(thumbnailUrl);
          // },

          languages: {
            en: {
              notice:
                'This content is hosted by a third party. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.spotify.com/de/legal/end-user-agreement/" target="_blank">terms and conditions</a> of spotify.com.',
              loadBtn: 'Load podcast',
              loadAllBtn: "Don't ask again",
            },
          },
        },
      },
    });
    // if (window.localStorage.getItem('cookieSet') !== 'true') {
    //   document.body.setAttribute('data-cookie-visible', '');
    // }

    // this.setEventListeners();
  }

  // setEventListeners = () => {
  //   this.element
  //     .querySelector('.cookie-banner-accept')
  //     .addEventListener('click', this.setCookie);
  // };

  // setCookie = () => {
  //   window.localStorage.setItem('cookieSet', 'true');
  //   document.body.removeAttribute('data-cookie-visible');
  // };
}

export default CookieBanner;
